export type InfoJobsAction =
  | { type: 'SET_IS_FETCHING_JOBS_CONTENT' }
  | { type: 'SET_FETCH_JOBS_CONTENT_FAILED' }
  | { type: 'SET_JOBS_CONTENT', content: Julius.Website.JobsPageViewModel };

  export const setIsFetching = (): InfoJobsAction => ({
    type: 'SET_IS_FETCHING_JOBS_CONTENT',
  });

  export const setFetchFailed = (): InfoJobsAction => ({
    type: 'SET_FETCH_JOBS_CONTENT_FAILED',
  });

  export const setJobsContent = (content: Julius.Website.JobsPageViewModel): InfoJobsAction => ({
    content,
    type: 'SET_JOBS_CONTENT',
  });


// WEBPACK FOOTER //
// ./src/components/InfoJobs/Redux/actions.tsx